module.exports = __webpack_public_path__ + "images/icons/icon-circle-close-blue.svg";